import { Component, OnInit } from '@angular/core';
import { PreferencesResponse } from '@app-core/models/core.model';
import { DataService } from '@app-core/services/data/data.service';

@Component({
  selector: 'app-notification-banner',
  templateUrl: './notification-banner.component.html',
  styleUrls: ['./notification-banner.component.scss'],
})
export class NotificationBannerComponent implements OnInit {
  public showBanner: boolean;
  public showEnabledBanner: boolean;
  public daysRemaining?: number;
  public formattedDate?: string;
  public showDisabledBanner: boolean;
  public showExpireBanner: boolean;
  // public isDismissed: boolean;
  constructor(public dataService: DataService) {}

  ngOnInit(): void {
    this.getFleetDetails();
  }

  public dismissBanner() {
    // this.isDismissed = true;
    this.showBanner = false;
  }

  public getFleetDetails() {
    this.dataService.getFleetDetails().subscribe({
      next: (res: PreferencesResponse) => {
        if (res?.pilotModeConfiguration?.isEnabled) {
          this.showBanner = true;
          this.showEnabledBanner = res?.pilotModeConfiguration?.isEnabled;
          this.getExpiryDateAndDays(res?.pilotModeConfiguration?.expiryDateUTC);
        }

        if (this.checkPilotModeExpiry(res?.pilotModeConfiguration?.expiryDateUTC)) {
          this.showBanner = false;
        }

        if (res?.pilotModeConfiguration?.isEnabled === false) {
          this.showBanner = true;
          this.showDisabledBanner = true;
        }
      },
    });
  }

  private checkPilotModeExpiry(expiryDateUTC) {
    const expiryDate = new Date(expiryDateUTC);
    const today = new Date();
    return expiryDate < today;
  }

  private getExpiryDateAndDays(date) {
    const expiryIsoDate = date;
    const expiryDate = new Date(expiryIsoDate);
    const today = new Date();

    const timeDiff = expiryDate.getTime() - today.getTime();
    this.daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    if (this.daysRemaining == 2) {
      this.showEnabledBanner = false;
      this.showExpireBanner = true;
      this.showBanner = true;
    }
    const day = expiryDate.getDate().toString().padStart(2, '0');
    const month = (expiryDate.getMonth() + 1).toString().padStart(2, '0');
    const year = expiryDate.getFullYear();

    this.formattedDate = `${day}/${month}/${year}`;
  }
}
